// src/components/GroupDetail/components/ItemGroupsTable/DeleteItemSelectionModal/DeleteItemSelectionModal.tsx

import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { RemoveselectionGroupFromItem } from '../../../../../../../../../../crud/menu_api/selection_groups';
import { toast } from 'react-toastify';

interface ItemSelectionType {
    item_id: number;
    selection_group_id: number;
    item_name: string;
    item_label: string;
    min_variance: number;
    max_variance: number;
    max_selections: number;
    min_selections: number;
    local_id: number;
    is_price_modifier: boolean;
  }

interface SelectionGroupType {
    readonly selection_group_id: number;
    selection_group_name: string;
    selection_group_description?: string;
    local_id: number;
  }

interface RemoveGroupFromItemModalProps {
  show: boolean;
  handleClose: () => void;
  sg: SelectionGroupType;
  itemSelection: ItemSelectionType;
  setItemSelections: (items: ItemSelectionType[]) => void;
  itemSelections: ItemSelectionType[];
}

const RemoveGroupFromItemModal: React.FC<RemoveGroupFromItemModalProps> = ({
  show,
  handleClose,
  sg,
  itemSelection,
  setItemSelections,
  itemSelections,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleDelete = () => {
    setLoading(true);
    RemoveselectionGroupFromItem(itemSelection.item_id,sg.selection_group_id)
      .then(() => {
        toast.success('Ítem seleccionado eliminado exitosamente.');
        // Filtrar el ítem eliminado de la lista
        const updatedItems = itemSelections.filter(
          (item) => (item.item_id !== itemSelection.item_id && item.selection_group_id !== sg.selection_group_id)
        );
        setItemSelections(updatedItems);
        handleClose();
      })
      .catch((error:any) => {
        console.error('Error eliminando el ítem seleccionado', error);
        const message =
          error.response?.data?.message || 'Error al eliminar el ítem seleccionado.';
        toast.error(message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header >
        <Modal.Title>Desvincular grupo de item</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          ¿Estás seguro de que deseas desvincular <strong>{sg.selection_group_name}</strong> del item <strong>{itemSelection.item_name}</strong>  ?
        </p>
        <p>
          Esta acción no se puede deshacer.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={loading}>
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{' '}
              Eliminando...
            </>
          ) : (
            'Eliminar'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveGroupFromItemModal;
